/**
 * ============================================================
 * CDS — Header (JS externalise)
 * Studio  : Chlo' Design Studio
 * Version : 3.1
 * Desc.   : Externalise depuis sections/cds-en-tete.liquid pour
 *           beneficier du cache navigateur (l'en-tete est
 *           recharge sur chaque page). Regroupe les scripts
 *           inline d'origine, executes dans le meme ordre :
 *             1. Scroll / sticky / transparent / spacer guard /
 *                mega menu / dropdown overflow / bascule compacte /
 *                compteur favoris / barre de recherche inline
 *             2. Menu drawer mobile (styles fullscreen / moderne)
 *             3. Autocomplete de recherche (header + drawer menu
 *                + panneau de recherche), cablee sur les reglages
 *                globaux "Suggestions automatiques"
 *             4. Panneau de recherche (style "drawer")
 *             5. Raccourci clavier Cmd+K / Ctrl+K — point d'entree
 *                unique openSearch() qui ouvre le mode actif.
 *                Remplace le raccourci natif Horizon, retire avec
 *                predictive-search.js (modale supprimee).
 *           La config par section (sectionId, stickyMode,
 *           floating, showInlineSearch, showSearchDrawer,
 *           predictive*, moneyFormat) est lue depuis
 *           <script type="application/json" data-hg-config>.
 * ============================================================
 */
(function () {
  var _heCfgEl = document.querySelector('[data-hg-config]');
  var cfg = _heCfgEl ? JSON.parse(_heCfgEl.textContent) : { sectionId: '', stickyMode: 'always', floating: false, showInlineSearch: false, showSearchDrawer: false, predictiveEnabled: true, predictiveMaxResults: 5, predictiveShowPrices: true, predictiveShowImages: true, moneyFormat: '' };

  /* Point d'entree unique — ouvre le mode de recherche actif.
     Assigne par le bloc "barre inline" (openBar) ou "panneau de
     recherche" (openSearchDrawer) selon search_style ; reste un
     no-op si la recherche est desactivee. */
  var openSearch = function () {};

  /* ============================================================
     SCRIPT 1 — Scroll, sticky, transparent, spacer guard, mega
     menu, dropdown overflow, nav overflow, favoris, recherche inline
     ============================================================ */
  (function() {
    var header = document.getElementById('cds-header-' + cfg.sectionId);
    if (!header) return;

    var isTransparent = header.getAttribute('data-transparent') === 'true';
    var scrollThreshold = 50;
    var stickyMode = cfg.stickyMode;
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var headerHidden = false;
    var wasScrolled = false;
    var floatSyncTimeout = null;

    /* Seuil de re-dock = hauteur reelle de la barre d'annonce (fallback 50 si
       absente) plutot qu'une constante arbitraire : le header rejoint top:0
       exactement quand l'annbar a fini de defiler hors champ. */
    var annbarHeight = 0; /* hauteur reelle (0 sans barre) — pilote le top continu */
    function syncScrollThreshold() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--cds-annbar-height');
      var n = parseFloat(raw);
      annbarHeight = (!isNaN(n) && n > 0) ? n : 0;
      scrollThreshold = annbarHeight > 0 ? annbarHeight : 50;
    }
    syncScrollThreshold();

    /* Le header fixe SUIT le bas de la barre d'annonce pendant qu'elle
       defile (top = hauteur restante visible de la barre), au lieu de
       rester cale a sa position initiale jusqu'au seuil : c'etait la
       bande blanche qui s'ouvrait entre la barre et le header sur les
       premiers pixels de scroll. Sans barre d'annonce : top 0 constant. */
    function applyHeaderTop(scrollY) {
      if (annbarHeight <= 0) {
        if (header.style.top) header.style.top = '';
        return;
      }
      var top = annbarHeight - scrollY;
      if (top < 0) top = 0;
      header.style.top = top + 'px';
    }

    /* --cds-header-height : la valeur Liquid statique (fallback initial) ne
       couvre pas le layout 2 rangees. Recalcul au pixel reel, meme logique
       que syncSpacer plus bas. Consommateurs (cds-panier, cds-produit-vedette
       sticky) lisent la var sans modification necessaire de leur cote. */
    function syncHeaderHeightVar() {
      var h = header.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--cds-header-height', h + 'px');
    }
    syncHeaderHeightVar();

    var headerMetricsRAF = null;
    function onHeaderMetricsResize() {
      if (headerMetricsRAF) return;
      headerMetricsRAF = requestAnimationFrame(function() {
        headerMetricsRAF = null;
        syncScrollThreshold();
        syncHeaderHeightVar();
      });
    }
    window.addEventListener('resize', onHeaderMetricsResize, { passive: true });

    /* Active la transition sur top (cf. .cds-hg-transitions-ready dans le
       style de la section) seulement une fois le premier paint stabilise :
       evite le glissement visible pendant que l'annbar pose sa hauteur reelle. */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        document.documentElement.classList.add('cds-hg-transitions-ready');
      });
    });

    function handleScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      applyHeaderTop(scrollY);

      /* Scrolled state toggle — only touch DOM when state actually changes */
      var isScrolled = scrollY > scrollThreshold;
      if (isScrolled !== wasScrolled) {
        wasScrolled = isScrolled;
        if (isScrolled) {
          header.classList.add('cds-hg--scrolled');
          if (isTransparent) header.classList.remove('cds-hg--transparent');
        } else {
          header.classList.remove('cds-hg--scrolled');
          if (isTransparent) header.classList.add('cds-hg--transparent');
        }
        /* Header flottant + transparent : la carte scrolled ajoute 12px de
           padding-top au wrapper (anime en 0.35s) → offsetHeight change avec
           l'etat. Re-mesure --cds-header-height apres la transition pour les
           consommateurs sticky (cds-panier, cds-produit-vedette). En mode
           opaque le padding est constant, rien a re-mesurer. */
        if (cfg.floating && isTransparent) {
          clearTimeout(floatSyncTimeout);
          floatSyncTimeout = setTimeout(syncHeaderHeightVar, 400);
          /* La barre passe pleine largeur ↔ carte : le module de bascule
             compacte doit re-mesurer le debordement une fois la largeur
             stabilisee */
          document.dispatchEvent(new CustomEvent('cds:header:floatstate'));
        }
      }

      /* Sticky scroll-up mode: hide/show header based on direction */
      if (stickyMode === 'scroll_up') {
        if (scrollY <= scrollThreshold) {
          if (headerHidden) { header.classList.remove('cds-hg--hidden'); headerHidden = false; }
        } else if (scrollY > lastScrollY) {
          if (!headerHidden) { header.classList.add('cds-hg--hidden'); headerHidden = true; }
        } else if (scrollY < lastScrollY) {
          if (headerHidden) { header.classList.remove('cds-hg--hidden'); headerHidden = false; }
        }
      }

      lastScrollY = scrollY;
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    /* Sync spacer height with actual header height (skip if transparent) */
    var spacer = header.nextElementSibling;
    if (spacer && spacer.classList.contains('cds-hg__spacer')) {
      var lastSpacerHeight = null;
      var isSelfModifying = false;

      function syncSpacer() {
        var newHeight;
        if (isTransparent) {
          newHeight = '0px';
        } else {
          /* Spacer compensates ONLY the fixed header — annbar is in normal flow */
          var h = header.offsetHeight;
          if (h <= 0) return;
          newHeight = h + 'px';
        }
        lastSpacerHeight = newHeight;
        if (spacer.style.height !== newHeight) {
          isSelfModifying = true;
          spacer.style.height = newHeight;
          /* Release flag after microtask queue drains so spacerGuardObserver
             (qui fire en microtask) voit le flag encore actif */
          setTimeout(function() { isSelfModifying = false; }, 0);
        }
      }
      syncSpacer();
      window.addEventListener('resize', syncSpacer, { passive: true });
      /* Re-sync after fonts/images load */
      window.addEventListener('load', syncSpacer);
      /* Re-sync after announcement bar sets --cds-annbar-height (may load after header) */
      setTimeout(syncSpacer, 100);
      setTimeout(syncSpacer, 500);
      /* Watch for annbar height changes (CSS var sur <html>) */
      var annbarObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'style') {
            syncSpacer();
            /* La hauteur de la barre a pu changer : re-cale le top continu. */
            syncScrollThreshold();
            applyHeaderTop(window.scrollY || window.pageYOffset);
          }
        });
      });
      annbarObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

      /* Guard contre le code natif Horizon qui écrase la hauteur du spacer
         sur cart:refresh / fermeture du dialog / mise à jour quantité.
         Sans ce guard, le spacer flippe 110px → 89px → 110px = shift de 21px
         visible sur la fiche produit. Le flag isSelfModifying évite la boucle
         infinie (l'observer ignore sa propre modification). */
      var spacerGuardObserver = new MutationObserver(function() {
        if (isSelfModifying) return;
        if (lastSpacerHeight == null) return;
        if (spacer.style.height !== lastSpacerHeight) {
          isSelfModifying = true;
          spacer.style.height = lastSpacerHeight;
          setTimeout(function() { isSelfModifying = false; }, 0);
        }
      });
      spacerGuardObserver.observe(spacer, { attributes: true, attributeFilter: ['style'] });

      /* Cleanup éditeur de thème (T10 finding #2) : scroll, resize/load du spacer et
         annbarObserver n'étaient jamais retirés au rechargement de section. Le
         spacerGuardObserver (garde anti-flip ci-dessus) n'est volontairement PAS
         touché ici : absent de la liste du finding, laissé actif tel quel. */
      document.addEventListener('shopify:section:unload', function(e) {
        if (e.detail.sectionId === cfg.sectionId) {
          window.removeEventListener('scroll', handleScroll);
          window.removeEventListener('resize', syncSpacer);
          window.removeEventListener('load', syncSpacer);
          annbarObserver.disconnect();
          window.removeEventListener('resize', onHeaderMetricsResize);
          if (headerMetricsRAF) { cancelAnimationFrame(headerMetricsRAF); headerMetricsRAF = null; }
          clearTimeout(floatSyncTimeout);
        }
      });
    }

    /* Shopify Design Mode */
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail.sectionId === cfg.sectionId) {
          /* Re-capture la reference header sur le nouveau DOM. Les sous-modules
             (mega, dropdown overflow fix, bascule compacte, favoris, recherche inline)
             lisent cette meme variable partagee dans leurs propres listeners
             shopify:section:load, enregistres plus loin donc executes apres celui-ci. */
          var freshHeader = document.getElementById('cds-header-' + cfg.sectionId);
          if (freshHeader) header = freshHeader;
          syncScrollThreshold();
          syncHeaderHeightVar();
          handleScroll();
        }
      });
    }

    /* ====================================================
       Mega Menu Hover Logic
       ==================================================== */
    (function() {
      var triggers = header.querySelectorAll('[data-mega-trigger]');
      var panels = header.querySelectorAll('[data-mega-panel]');
      var hoverTimeout;
      var openIntentTimeout;
      var megaResizeRAF = null;
      var activePanel = null;
      var activeTrigger = null;
      var canHover = window.matchMedia('(hover: hover)').matches;

      /* Backdrop overlay */
      var backdrop = document.createElement('div');
      backdrop.className = 'cds-hg__mega-backdrop';
      document.body.appendChild(backdrop);

      function updateMegaTop() {
        var bar = header.querySelector('.cds-hg__bar');
        if (!bar) return;
        var rect = bar.getBoundingClientRect();
        panels.forEach(function(p) {
          p.style.top = rect.bottom + 'px';
        });
      }

      /* Set initial position immediately */
      updateMegaTop();

      /* Recalcule au resize (throttle rAF), seulement si un panneau est ouvert :
         la hauteur de la barre peut changer pendant l'affichage d'un mega
         (retour a la ligne du menu, rotation mobile/tablette). */
      function onMegaResize() {
        if (!activePanel) return;
        if (megaResizeRAF) return;
        megaResizeRAF = requestAnimationFrame(function() {
          megaResizeRAF = null;
          updateMegaTop();
        });
      }
      window.addEventListener('resize', onMegaResize, { passive: true });

      function setAriaExpanded(trigger, expanded) {
        var link = trigger.querySelector('.cds-hg__link[aria-expanded]');
        if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      function openMega(trigger) {
        var panel = trigger.querySelector('[data-mega-panel]');
        if (!panel) return;
        clearTimeout(hoverTimeout);
        clearTimeout(openIntentTimeout);
        if (activePanel && activePanel !== panel) {
          activePanel.classList.remove('is-open');
          if (activeTrigger) setAriaExpanded(activeTrigger, false);
        }
        updateMegaTop();
        panel.classList.add('is-open');
        setAriaExpanded(trigger, true);
        backdrop.classList.add('is-visible');
        activePanel = panel;
        activeTrigger = trigger;
      }

      function closeMega() {
        hoverTimeout = setTimeout(function() {
          if (activePanel) {
            activePanel.classList.remove('is-open');
            if (activeTrigger) setAriaExpanded(activeTrigger, false);
            backdrop.classList.remove('is-visible');
            activePanel = null;
            activeTrigger = null;
          }
        }, 200);
      }

      function closeImmediately() {
        clearTimeout(hoverTimeout);
        clearTimeout(openIntentTimeout);
        if (activePanel) {
          activePanel.classList.remove('is-open');
          if (activeTrigger) setAriaExpanded(activeTrigger, false);
          backdrop.classList.remove('is-visible');
          activePanel = null;
          activeTrigger = null;
        }
      }

      /* Cablage d'un trigger — reutilise a l'init et a la re-init editeur */
      function bindTrigger(trigger) {
        var triggerLink = trigger.querySelector('.cds-hg__link');

        if (canHover) {
          /* Desktop: hover to open, avec delai d'intention (~120ms) pour eviter
             le clignotement quand la souris traverse la barre de nav sans
             vouloir ouvrir un panneau. Annule au mouseleave si le trigger n'a
             pas ete survole assez longtemps. Le clavier (focusin plus bas)
             continue d'ouvrir immediatement, sans ce delai. */
          trigger.addEventListener('mouseenter', function() {
            clearTimeout(openIntentTimeout);
            openIntentTimeout = setTimeout(function() {
              openMega(trigger);
            }, 120);
          });
          trigger.addEventListener('mouseleave', function() {
            clearTimeout(openIntentTimeout);
            closeMega();
          });
        } else {
          /* Touch devices (tablet landscape >991px): 1er tap ouvre, 2e tap
             sur un trigger deja ouvert navigue vers le lien (comportement
             standard) au lieu de re-toggler. */
          if (triggerLink) {
            triggerLink.addEventListener('click', function(e) {
              if (activePanel && activeTrigger === trigger) {
                return;
              }
              e.preventDefault();
              openMega(trigger);
            });
          }
        }

        /* Clavier : ouverture/fermeture au focus, meme timing que le survol souris */
        trigger.addEventListener('focusin', function() {
          openMega(trigger);
        });
        trigger.addEventListener('focusout', function() {
          closeMega();
        });

        var panel = trigger.querySelector('[data-mega-panel]');
        if (panel) {
          panel.addEventListener('mouseenter', function() {
            clearTimeout(hoverTimeout);
          });
          panel.addEventListener('mouseleave', function() {
            closeMega();
          });
        }
      }
      triggers.forEach(bindTrigger);

      /* Close on backdrop click */
      backdrop.addEventListener('click', closeImmediately);

      /* Escape key closes mega menu */
      function onKeyDown(e) {
        if (e.key === 'Escape' && activePanel) {
          closeImmediately();
          if (activeTrigger) {
            var link = activeTrigger.querySelector('.cds-hg__link');
            if (link) link.focus();
          }
        }
      }
      document.addEventListener('keydown', onKeyDown);

      /* Close mega on scroll — only runs when a panel is open */
      function onScrollCloseMega() {
        if (!activePanel) return;
        closeImmediately();
      }
      window.addEventListener('scroll', onScrollCloseMega, { passive: true });

      /* Close on click outside */
      function onClickOutside(e) {
        if (activePanel && e.target && !e.target.closest('[data-mega-trigger]') && !e.target.closest('.cds-hg__mega-backdrop')) {
          closeImmediately();
        }
      }
      document.addEventListener('click', onClickOutside);

      /* Re-init editeur de theme : header est deja re-capture par le bloc Design
         Mode ci-dessus, ce module re-interroge ses propres elements dessus et
         re-cable (les triggers/panels precedents sont abandonnes avec l'ancien DOM,
         pas de double-bind possible sur des elements deja disparus). */
      function onMegaSectionLoad(e) {
        if (e.detail.sectionId !== cfg.sectionId) return;
        activePanel = null;
        activeTrigger = null;
        triggers = header.querySelectorAll('[data-mega-trigger]');
        panels = header.querySelectorAll('[data-mega-panel]');
        if (!backdrop.parentNode) document.body.appendChild(backdrop);
        updateMegaTop();
        triggers.forEach(bindTrigger);
      }
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', onMegaSectionLoad);
      }

      /* Cleanup for Theme Editor */
      document.addEventListener('shopify:section:unload', function(e) {
        if (e.detail.sectionId === cfg.sectionId) {
          window.removeEventListener('scroll', onScrollCloseMega);
          window.removeEventListener('resize', onMegaResize);
          if (megaResizeRAF) { cancelAnimationFrame(megaResizeRAF); megaResizeRAF = null; }
          clearTimeout(openIntentTimeout);
          document.removeEventListener('click', onClickOutside);
          document.removeEventListener('keydown', onKeyDown);
          document.removeEventListener('shopify:section:load', onMegaSectionLoad);
          if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
        }
      });
    })();

    /* ====================================================
       Dropdown Overflow Fix — Prevent dropdowns from going outside viewport
       ==================================================== */
    (function() {
      function bindDropdownItem(item) {
        var dropdown = item.querySelector('.cds-hg__dropdown');
        if (!dropdown) return;
        item.addEventListener('mouseenter', function() {
          /* Reset positioning */
          dropdown.classList.remove('cds-hg__dropdown--right', 'cds-hg__dropdown--left');
          /* Check if dropdown overflows right side of viewport */
          var rect = dropdown.getBoundingClientRect();
          var viewportW = window.innerWidth || document.documentElement.clientWidth;
          if (rect.right > viewportW - 10) {
            dropdown.classList.add('cds-hg__dropdown--right');
          } else if (rect.left < 10) {
            dropdown.classList.add('cds-hg__dropdown--left');
          }
        });
      }
      /* Niveau 3 : meme garde-fou viewport sur le sous-dropdown, au survol ET
         au focus clavier (le sous-dropdown s'ouvre aussi via :focus-within
         depuis la vague 1 — niveau 3 etait inatteignable au clavier). */
      function bindSubdropdownItem(item) {
        var subdropdown = item.querySelector('.cds-hg__subdropdown');
        if (!subdropdown) return;
        function checkSubOverflow() {
          subdropdown.classList.remove('cds-hg__subdropdown--left');
          var rect = subdropdown.getBoundingClientRect();
          var viewportW = window.innerWidth || document.documentElement.clientWidth;
          if (rect.right > viewportW - 10) {
            subdropdown.classList.add('cds-hg__subdropdown--left');
          }
        }
        item.addEventListener('mouseenter', checkSubOverflow);
        item.addEventListener('focusin', checkSubOverflow);
      }

      var navItems = header.querySelectorAll('.cds-hg__nav-item');
      navItems.forEach(bindDropdownItem);
      var subdropdownItems = header.querySelectorAll('.cds-hg__dropdown-item--has-sub');
      subdropdownItems.forEach(bindSubdropdownItem);

      /* Re-init editeur de theme : re-cablage sur le nouveau DOM (header deja
         re-capture par le bloc Design Mode) — les anciens items disparaissent
         avec l'ancien DOM, pas de double-bind possible. */
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(e) {
          if (e.detail.sectionId !== cfg.sectionId) return;
          header.querySelectorAll('.cds-hg__nav-item').forEach(bindDropdownItem);
          header.querySelectorAll('.cds-hg__dropdown-item--has-sub').forEach(bindSubdropdownItem);
        });
      }
    })();


    /* ====================================================
       Bascule compacte — le menu ne tient pas
       Quand la largeur requise par le menu complet depasse
       l'espace que la barre alloue a la nav, le header entier
       passe en disposition mobile (classe cds-hg--collapsed :
       burger > logo > icones, CSS >= 992px dans la section).
       Remplace l'ancien dropdown de debordement "...".
       ==================================================== */
    (function() {
      var COLLAPSED_CLASS = 'cds-hg--collapsed';
      var HYSTERESIS = 24; /* marge de redeploiement (px), anti-oscillation */
      var navContainers = header.querySelectorAll('.cds-hg__nav-left, .cds-hg__split-left, .cds-hg__split-right');
      if (!navContainers.length) return;

      /* Mesure d'un conteneur nav : largeur requise par le menu complet
         vs. espace que la barre lui alloue.
         - Requise : largeur rendue de .cds-hg__nav-list — la liste et ses
           items sont flex-shrink: 0, elle n'est jamais compressee : sa
           largeur EST la somme des largeurs naturelles des items + gaps,
           meme quand elle deborde de son conteneur.
         - Allouee : le nav est force le temps de la lecture a occuper
           toute sa colonne (flex-grow: 1 pour la nav logee dans
           .cds-hg__left, justify-self: stretch pour les navs split posees
           en grid) avec overflow: hidden (min-width auto resolu a 0),
           puis relache. Echange synchrone dans la meme tache JS : le
           navigateur ne peint jamais l'etat intermediaire.
         Renvoie null si la nav n'est pas rendue (mobile < 992px, layout
         "Menu drawer", menu vide) : aucune bascule dans ces modes. */
      function measureNav(nav) {
        var list = nav.querySelector('.cds-hg__nav-list');
        if (!list) return null;
        var required = list.getBoundingClientRect().width;
        if (!required) return null;
        var prevGrow = nav.style.flexGrow;
        var prevJustify = nav.style.justifySelf;
        var prevOverflow = nav.style.overflow;
        nav.style.flexGrow = '1';
        nav.style.justifySelf = 'stretch';
        nav.style.overflow = 'hidden';
        var navStyle = getComputedStyle(nav);
        var available = nav.clientWidth
          - (parseFloat(navStyle.paddingLeft) || 0)
          - (parseFloat(navStyle.paddingRight) || 0);
        nav.style.flexGrow = prevGrow;
        nav.style.justifySelf = prevJustify;
        nav.style.overflow = prevOverflow;
        return { required: required, available: available };
      }

      /* Anti-oscillation, deux garde-fous :
         1. La mesure se fait TOUJOURS en etat deploye : si le header est
            replie, la classe est retiree le temps de la mesure puis
            reposee (echange synchrone, aucun repaint intermediaire). On
            compare donc toujours la largeur requise TOTALE du menu a
            l'espace reellement disponible — jamais la largeur de l'etat
            affiche : le repli ne modifie pas sa propre condition, pas de
            boucle repli/redeploiement possible.
         2. Hysteresis : repli des que le menu ne tient plus, mais
            redeploiement seulement avec 24px de marge — les arrondis
            sous-pixel et l'apparition de l'ascenseur ne font pas
            clignoter le header a la frontiere. */
      function handleCollapse() {
        var wasCollapsed = header.classList.contains(COLLAPSED_CLASS);
        if (wasCollapsed) header.classList.remove(COLLAPSED_CLASS);
        var overflows = false;
        var fitsWithMargin = true;
        navContainers.forEach(function(nav) {
          var m = measureNav(nav);
          if (!m) return;
          if (m.required > m.available) overflows = true;
          if (m.required > m.available - HYSTERESIS) fitsWithMargin = false;
        });
        header.classList.toggle(COLLAPSED_CLASS, wasCollapsed ? !fitsWithMargin : overflows);
      }

      /* Run on load + resize (debounced) */
      var resizeTimer;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleCollapse, 120);
      }

      /* Initial run after layout is ready */
      if (document.readyState === 'complete') {
        handleCollapse();
      } else {
        window.addEventListener('load', handleCollapse);
      }
      window.addEventListener('resize', onResize, { passive: true });

      /* Re-check after fonts load (may change widths) */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(handleCollapse);
      }

      /* Header flottant + transparent : la largeur de la barre change avec
         l'etat scrolled (pleine largeur ↔ carte). Re-mesure apres la
         transition de largeur (0.4s) pour re-evaluer la bascule compacte */
      var floatCollapseTimer = null;
      function onFloatStateChange() {
        clearTimeout(floatCollapseTimer);
        floatCollapseTimer = setTimeout(handleCollapse, 450);
      }
      if (cfg.floating) {
        document.addEventListener('cds:header:floatstate', onFloatStateChange);
      }

      /* Re-init editeur de theme : re-interroge les conteneurs sur le nouveau DOM
         (header deja re-capture par le bloc Design Mode) et relance le calcul de
         bascule + le listener resize (retire par le cleanup unload ci-dessous). */
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(e) {
          if (e.detail.sectionId !== cfg.sectionId) return;
          navContainers = header.querySelectorAll('.cds-hg__nav-left, .cds-hg__split-left, .cds-hg__split-right');
          if (!navContainers.length) return;
          /* remove puis add : idempotent si shopify:section:load se repete sans unload entre deux */
          window.removeEventListener('resize', onResize);
          window.addEventListener('resize', onResize, { passive: true });
          handleCollapse();
        });
      }

      /* Cleanup */
      document.addEventListener('shopify:section:unload', function(e) {
        if (e.detail.sectionId === cfg.sectionId) {
          window.removeEventListener('resize', onResize);
          document.removeEventListener('cds:header:floatstate', onFloatStateChange);
          clearTimeout(floatCollapseTimer);
          clearTimeout(resizeTimer);
        }
      });
    })();

    /* ====================================================
       Wishlist Count Sync
       ==================================================== */
    (function() {
      var badge = header.querySelector('[data-wishlist-count]');
      if (!badge) return;
      function updateCount() {
        try {
          var wl = JSON.parse(localStorage.getItem('cds_wishlist') || '[]');
          var c = wl.length;
          if (c > 0) { badge.textContent = c; badge.style.display = 'flex'; }
          else { badge.style.display = 'none'; }
        } catch(e) { badge.style.display = 'none'; }
      }
      updateCount();
      window.addEventListener('storage', updateCount);
      document.addEventListener('cds:wishlist:updated', updateCount);

      /* Re-init editeur de theme : re-interroge le badge sur le nouveau DOM
         (header deja re-capture par le bloc Design Mode) et re-attache les
         listeners retires par le cleanup unload ci-dessous. */
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(e) {
          if (e.detail.sectionId !== cfg.sectionId) return;
          badge = header.querySelector('[data-wishlist-count]');
          if (!badge) return;
          updateCount();
          /* remove puis add : idempotent si shopify:section:load se repete sans unload entre deux */
          window.removeEventListener('storage', updateCount);
          window.addEventListener('storage', updateCount);
          document.removeEventListener('cds:wishlist:updated', updateCount);
          document.addEventListener('cds:wishlist:updated', updateCount);
        });
      }

      /* Cleanup éditeur de thème (T10 finding #2) */
      document.addEventListener('shopify:section:unload', function(e) {
        if (e.detail.sectionId === cfg.sectionId) {
          window.removeEventListener('storage', updateCount);
          document.removeEventListener('cds:wishlist:updated', updateCount);
        }
      });
    })();

    /* === Inline search bar toggle === */
    if (cfg.showInlineSearch) {
    (function() {
      var bar = header.querySelector('[data-cds-search-bar]');
      if (!bar) return;
      var input = bar.querySelector('[data-cds-search-input]');
      var toggles = header.querySelectorAll('[data-cds-search-toggle]');
      var closes = bar.querySelectorAll('[data-cds-search-close]');

      function openBar() {
        bar.classList.add('is-open');
        bar.setAttribute('aria-hidden', 'false');
        bar.inert = false;
        if (input) {
          setTimeout(function() { input.focus(); }, 200);
        }
      }
      function closeBar() {
        bar.classList.remove('is-open');
        bar.setAttribute('aria-hidden', 'true');
        bar.inert = true;
      }
      function toggleBar() {
        if (bar.classList.contains('is-open')) closeBar();
        else openBar();
      }

      /* Point d'entree partage (raccourci clavier) — "deplie+focus",
         sans toggle : le clic loupe garde son comportement (toggleBar)
         ci-dessous, inchange. */
      openSearch = openBar;

      toggles.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          toggleBar();
        });
      });
      closes.forEach(function(btn) {
        btn.addEventListener('click', closeBar);
      });
      function onSearchBarKeydown(e) {
        if (e.key === 'Escape' && bar.classList.contains('is-open')) {
          closeBar();
        }
      }
      document.addEventListener('keydown', onSearchBarKeydown);

      /* Re-init editeur de theme : re-interroge les elements sur le nouveau DOM
         (header deja re-capture par le bloc Design Mode) et re-cable — les anciens
         boutons disparaissent avec l'ancien DOM, pas de double-bind possible sur eux. */
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(e) {
          if (e.detail.sectionId !== cfg.sectionId) return;
          bar = header.querySelector('[data-cds-search-bar]');
          if (!bar) return;
          input = bar.querySelector('[data-cds-search-input]');
          toggles = header.querySelectorAll('[data-cds-search-toggle]');
          closes = bar.querySelectorAll('[data-cds-search-close]');
          toggles.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              toggleBar();
            });
          });
          closes.forEach(function(btn) {
            btn.addEventListener('click', closeBar);
          });
          /* remove puis add : idempotent si shopify:section:load se repete sans unload entre deux */
          document.removeEventListener('keydown', onSearchBarKeydown);
          document.addEventListener('keydown', onSearchBarKeydown);
        });
      }

      /* Cleanup éditeur de thème (T10 finding #2) : ce keydown document n'était
         jamais retiré au rechargement de section. */
      document.addEventListener('shopify:section:unload', function(e) {
        if (e.detail.sectionId === cfg.sectionId) {
          document.removeEventListener('keydown', onSearchBarKeydown);
        }
      });
    })();
    }
  })();

  /* ============================================================
     SCRIPT 2 — CDS Drawer Menu (styles fullscreen / moderne)
     ============================================================ */
(function() {
  var drawer = document.getElementById('cds-drawer-menu');
  if (!drawer) return;

  var style = drawer.getAttribute('data-drawer-style') || 'modern';

  /* Move drawer to body root to avoid stacking context issues */
  document.body.appendChild(drawer);

  var panel = drawer.querySelector('.cds-dm__panel');
  var triggers = document.querySelectorAll('[data-cds-dm-open-drawer]');
  var lastTrigger = null;
  var openFocusTimeout = null;
  var closeResetTimeout = null;
  var inertSiblings = [];

  /* Piege Tab : tant que le drawer est ouvert, Tab/Shift+Tab reste dans .cds-dm__panel */
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(focusable, function(el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open(trigger) {
    clearTimeout(openFocusTimeout);
    clearTimeout(closeResetTimeout);
    lastTrigger = trigger || lastTrigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (style === 'fullscreen') {
      document.body.classList.add('cds-dm-fs-open');
    }
    triggers.forEach(function(t) {
      t.setAttribute('aria-expanded', 'true');
      t.classList.add('is-active');
    });
    /* Modale : le reste de la page devient inert tant que le drawer est ouvert */
    inertSiblings = [];
    Array.prototype.forEach.call(document.body.children, function(el) {
      if (el === drawer || el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      inertSiblings.push(el);
    });
    document.addEventListener('keydown', trapFocus);
    openFocusTimeout = setTimeout(function() {
      var firstLink = panel.querySelector('a, button:not([data-cds-dm-close])');
      if (firstLink) firstLink.focus();
    }, 350);
  }

  function close() {
    clearTimeout(openFocusTimeout);
    clearTimeout(closeResetTimeout);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (style === 'fullscreen') {
      document.body.classList.remove('cds-dm-fs-open');
    }
    triggers.forEach(function(t) {
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('is-active');
    });
    document.removeEventListener('keydown', trapFocus);
    inertSiblings.forEach(function(el) { el.removeAttribute('inert'); });
    inertSiblings = [];
    if (lastTrigger) { lastTrigger.focus(); }
    closeResetTimeout = setTimeout(function() {
      var openItems = drawer.querySelectorAll('.is-open');
      for (var i = 0; i < openItems.length; i++) {
        openItems[i].classList.remove('is-open');
      }
      var toggles = drawer.querySelectorAll('.js-cds-dm-toggle');
      for (var j = 0; j < toggles.length; j++) {
        toggles[j].setAttribute('aria-expanded', 'false');
      }
      var togglesL2 = drawer.querySelectorAll('.js-cds-dm-toggle-l2');
      for (var k = 0; k < togglesL2.length; k++) {
        togglesL2[k].setAttribute('aria-expanded', 'false');
      }
      if (style === 'modern') {
        var mLevels = drawer.querySelectorAll('.cds-dm__level');
        for (var m = 0; m < mLevels.length; m++) {
          mLevels[m].classList.remove('is-active', 'is-exiting');
        }
        var mRoot = drawer.querySelector('.cds-dm__level--1');
        if (mRoot) mRoot.classList.add('is-active');
      }
    }, 450);
  }

  /* Bind open triggers */
  triggers.forEach(function(t) {
    t.addEventListener('click', function(e) {
      e.preventDefault();
      open(t);
    });
  });

  /* Close buttons + backdrop */
  drawer.querySelectorAll('[data-cds-dm-close]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      close();
    });
  });

  /* Accordion toggles (fullscreen) */
  drawer.querySelectorAll('.js-cds-dm-toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('is-open');
      /* Close siblings (:scope > pour ne pas toucher les sous-niveaux L2) */
      var parent = item.parentElement;
      var siblings = parent.querySelectorAll(':scope > .has-sub');
      for (var j = 0; j < siblings.length; j++) {
        siblings[j].classList.remove('is-open');
        var sibBtn = siblings[j].querySelector('.js-cds-dm-toggle');
        if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
      }
      /* Toggle current */
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Level 2 accordion (sub-sub-menus) */
  drawer.querySelectorAll('.js-cds-dm-toggle-l2').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('is-open');
      /* Close L2 siblings */
      var siblings = item.parentElement.querySelectorAll(':scope > .has-sub');
      for (var j = 0; j < siblings.length; j++) {
        siblings[j].classList.remove('is-open');
        var sibBtn = siblings[j].querySelector('.js-cds-dm-toggle-l2');
        if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
      }
      /* Toggle current */
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Modern style — sliding panels (push / pop) */
  function showLevel(targetId) {
    var target = drawer.querySelector('.cds-dm__level[data-level="' + targetId + '"]');
    if (!target) return;
    var current = drawer.querySelector('.cds-dm__level.is-active');
    if (current && current !== target) {
      current.classList.remove('is-active');
      current.classList.add('is-exiting');
    }
    target.classList.remove('is-exiting');
    target.classList.add('is-active');
    var sc = target.querySelector('.cds-dm__lv-scroll');
    if (sc) sc.scrollTop = 0;
  }
  function goBack(levelEl) {
    if (!levelEl) return;
    var parentId = levelEl.getAttribute('data-parent');
    levelEl.classList.remove('is-active');
    if (!parentId) return;
    var parent = drawer.querySelector('.cds-dm__level[data-level="' + parentId + '"]');
    if (parent) {
      parent.classList.remove('is-exiting');
      parent.classList.add('is-active');
    }
  }
  drawer.querySelectorAll('.js-cds-dm-push').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      showLevel(btn.getAttribute('data-target'));
    });
  });
  drawer.querySelectorAll('.js-cds-dm-back').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      goBack(btn.closest('.cds-dm__level'));
    });
  });

  /* Selecteurs langue / pays-devise (footer du drawer) : soumission du
     form localization au change — meme pattern que cds-barre-annonce,
     attribut dedie pour ne pas croiser les selects de la barre d'annonce. */
  drawer.querySelectorAll('[data-cds-dm-locale-select]').forEach(function(select) {
    select.addEventListener('change', function() {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });

  /* Escape key */
  function onDrawerKeydown(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      close();
    }
  }
  document.addEventListener('keydown', onDrawerKeydown);

  /* Swipe to close */
  var touchStartX = 0, touchStartY = 0, swiping = false;
  var swipeTarget = style === 'fullscreen' ? drawer : panel;
  if (swipeTarget) {
    swipeTarget.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      /* Fullscreen : n'arme le swipe que si le panneau est deja scrolle en haut,
         sinon un scroll vers le bas du contenu serait interprete comme une fermeture */
      swiping = style === 'fullscreen' ? panel.scrollTop === 0 : true;
    }, { passive: true });
    swipeTarget.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (style === 'modern' && Math.abs(dy) > Math.abs(dx)) swiping = false;
      if (style === 'fullscreen' && Math.abs(dx) > Math.abs(dy)) swiping = false;
    }, { passive: true });
    swipeTarget.addEventListener('touchend', function(e) {
      if (!swiping) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (style === 'fullscreen' && dy > 120) close();
      else if (style === 'modern') {
        var activeLevel = drawer.querySelector('.cds-dm__level.is-active');
        var atRoot = activeLevel && activeLevel.classList.contains('cds-dm__level--1');
        if (dx > 70 && !atRoot) goBack(activeLevel);
        else if (dx < -80 && atRoot) close();
      }
      swiping = false;
    }, { passive: true });
  }

  /* Shopify Theme Editor */
  function onSectionLoad(e) {
    if (e.detail.sectionId === cfg.sectionId) {
      triggers = document.querySelectorAll('[data-cds-dm-open-drawer]');
      triggers.forEach(function(t) {
        t.addEventListener('click', function(ev) { ev.preventDefault(); open(t); });
      });
    }
  }
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  /* Cleanup éditeur de thème (T10 finding #1 et #2) : au rechargement de CETTE
     section, retire du body le drawer téléporté par cette instance et ses
     listeners document (keydown Echap, shopify:section:load) — sans ça, chaque
     rechargement empile un nouveau #cds-drawer-menu et rebinde les triggers
     courants sur l'open() périmé de l'ancienne instance (double ouverture). */
  document.addEventListener('shopify:section:unload', function(e) {
    if (e.detail.sectionId === cfg.sectionId) {
      document.removeEventListener('keydown', onDrawerKeydown);
      document.removeEventListener('shopify:section:load', onSectionLoad);
      if (drawer.parentNode) drawer.parentNode.removeChild(drawer);
    }
  });
})();

  /* ============================================================
     SCRIPT 3 — Recherche : suggestions (autocomplete partage
     header + drawer menu + panneau de recherche). Reglage
     global "Afficher des suggestions pendant la saisie" coupe
     tout le module (aucun des 3 consommateurs n'a d'autocomplete).
     ============================================================ */
(function() {
  var scopes = document.querySelectorAll('[data-cds-ac]');
  if (!scopes.length || !cfg.predictiveEnabled) return;
  var maxResults = cfg.predictiveMaxResults || 5;
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  scopes.forEach(function(scope) {
    var input = scope.querySelector('[data-cds-ac-input]');
    var results = scope.querySelector('[data-cds-ac-results]');
    if (!input || !results) return;
    var form = scope.querySelector('form');
    var searchUrl = (form && form.getAttribute('action')) || '/search';
    var timer, lastQ = '', ctrl;
    var activeIndex = -1;

    /* Semantique combobox — id/role poses en dur cote Liquid ; filet de securite ici */
    if (!results.id) results.id = 'cds-ac-results-' + Math.random().toString(36).slice(2, 8);
    results.setAttribute('role', 'listbox');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-expanded', 'false');

    function setExpanded(expanded) { input.setAttribute('aria-expanded', expanded ? 'true' : 'false'); }

    function setActive(index) {
      var options = results.querySelectorAll('[role="option"]');
      if (!options.length) return;
      if (index < 0) index = options.length - 1;
      if (index >= options.length) index = 0;
      options.forEach(function(opt) { opt.classList.remove('is-active'); });
      activeIndex = index;
      options[activeIndex].classList.add('is-active');
      input.setAttribute('aria-activedescendant', options[activeIndex].id);
    }

    function hide() {
      results.hidden = true;
      results.innerHTML = '';
      activeIndex = -1;
      setExpanded(false);
      input.removeAttribute('aria-activedescendant');
    }

    function show(products, articles, q) {
      var html = '';
      var optId = 0;
      function itemImg(src) {
        if (!cfg.predictiveShowImages) return '';
        return src
          ? '<img class="cds-ac__img" src="' + esc(src) + '" alt="" loading="lazy" width="42" height="42">'
          : '<span class="cds-ac__img"></span>';
      }
      if (products.length) html += '<div class="cds-ac__group-label">Produits</div>';
      products.slice(0, maxResults).forEach(function(p) {
        var priceHtml = '';
        if (cfg.predictiveShowPrices && p.price != null && window.CDSMoney) {
          priceHtml = '<span class="cds-ac__price">' + esc(window.CDSMoney.format(Math.round(p.price * 100), cfg.moneyFormat)) + '</span>';
        }
        html += '<a class="cds-ac__item" role="option" id="' + results.id + '-opt-' + (optId++) + '" href="' + esc(p.url) + '">' + itemImg(p.image) +
          '<span class="cds-ac__text"><span class="cds-ac__title">' + esc(p.title) + '</span>' + priceHtml + '</span></a>';
      });
      if (articles.length) {
        html += '<div class="cds-ac__group-label">Articles de blog</div>';
        articles.slice(0, 3).forEach(function(a) {
          html += '<a class="cds-ac__item" role="option" id="' + results.id + '-opt-' + (optId++) + '" href="' + esc(a.url) + '">' + itemImg(a.image) +
            '<span class="cds-ac__text"><span class="cds-ac__title">' + esc(a.title) + '</span></span></a>';
        });
      }
      html += '<a class="cds-ac__more" role="option" id="' + results.id + '-opt-more" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&type=product,article">Voir plus</a>';
      results.innerHTML = html;
      results.hidden = false;
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      setExpanded(true);
    }

    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); lastQ = ''; return; }
      if (q === lastQ) return;
      timer = setTimeout(function() {
        lastQ = q;
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        fetch(searchUrl + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=' + maxResults + '&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : undefined)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var res = (data.resources && data.resources.results) || {};
            var products = (res.products || []).filter(function(p) {
              return !(p.tags && p.tags.indexOf && p.tags.indexOf('Hidden') > -1);
            });
            var articles = res.articles || [];
            if (products.length || articles.length) show(products, articles, q);
            else {
              results.innerHTML = '<div class="cds-ac__empty">Aucun résultat</div>';
              results.hidden = false;
              activeIndex = -1;
              input.removeAttribute('aria-activedescendant');
              setExpanded(true);
            }
          })
          .catch(function(err) { if (!err || err.name !== 'AbortError') hide(); });
      }, 220);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { hide(); return; }
      if (results.hidden) return;
      var options = results.querySelectorAll('[role="option"]');
      if (!options.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex - 1);
      } else if (e.key === 'Enter' && activeIndex > -1) {
        e.preventDefault();
        window.location.href = options[activeIndex].href;
      }
    });
    function onAcDocumentClick(e) {
      if (!scope.contains(e.target) || e.target.closest('[data-cds-search-close]')) hide();
    }
    document.addEventListener('click', onAcDocumentClick);

    /* Cleanup éditeur de thème (T10 finding #2) */
    document.addEventListener('shopify:section:unload', function(e) {
      if (e.detail.sectionId === cfg.sectionId) {
        document.removeEventListener('click', onAcDocumentClick);
      }
    });
  });
})();

  /* ============================================================
     SCRIPT 4 — Panneau de recherche (search_style = "drawer").
     Meme pattern a11y que le menu drawer (SCRIPT 2) : focus trap
     + inert sur les siblings + Echap + retour du focus au
     declencheur. Teleporte vers body (evite le containing block
     cree par le transform du header sticky).
     ============================================================ */
(function() {
  var sd = document.getElementById('cds-search-drawer-' + cfg.sectionId);
  if (!sd || !cfg.showSearchDrawer) return;

  document.body.appendChild(sd);

  var panel = sd.querySelector('.cds-sd__panel');
  var input = sd.querySelector('[data-cds-ac-input]');
  var toggles = document.querySelectorAll('[data-cds-search-toggle]');
  var lastTrigger = null;
  var focusTimeout = null;
  var inertSiblings = [];

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(focusable, function(el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && sd.classList.contains('is-open')) close();
  }

  function open(trigger) {
    clearTimeout(focusTimeout);
    lastTrigger = trigger || lastTrigger || document.activeElement;
    sd.classList.add('is-open');
    sd.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    inertSiblings = [];
    Array.prototype.forEach.call(document.body.children, function(el) {
      if (el === sd || el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      inertSiblings.push(el);
    });
    document.addEventListener('keydown', trapFocus);
    document.addEventListener('keydown', onKeydown);
    focusTimeout = setTimeout(function() {
      if (input) input.focus();
    }, 350);
  }

  function close() {
    clearTimeout(focusTimeout);
    sd.classList.remove('is-open');
    sd.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', trapFocus);
    document.removeEventListener('keydown', onKeydown);
    inertSiblings.forEach(function(el) { el.removeAttribute('inert'); });
    inertSiblings = [];
    if (lastTrigger) lastTrigger.focus();
  }

  toggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      open(btn);
    });
  });
  sd.querySelectorAll('[data-cds-sd-close]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      close();
    });
  });

  /* Point d'entree partage (raccourci clavier) — "ouvre+focus champ" */
  openSearch = open;

  /* Re-init editeur de theme : re-interroge les declencheurs sur le
     nouveau DOM (le panneau lui-meme est deja recapture au-dessus)
     et re-cable — les anciens boutons disparaissent avec l'ancien DOM. */
  function onSectionLoad(e) {
    if (e.detail.sectionId !== cfg.sectionId) return;
    toggles = document.querySelectorAll('[data-cds-search-toggle]');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function(ev) { ev.preventDefault(); open(btn); });
    });
  }
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  /* Cleanup editeur de theme : retire du body le panneau teleporte
     par cette instance et ses listeners document, meme logique que
     le menu drawer (SCRIPT 2) pour eviter les doubles ouvertures. */
  document.addEventListener('shopify:section:unload', function(e) {
    if (e.detail.sectionId === cfg.sectionId) {
      document.removeEventListener('keydown', trapFocus);
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('shopify:section:load', onSectionLoad);
      if (sd.parentNode) sd.parentNode.removeChild(sd);
    }
  });
})();

  /* ============================================================
     SCRIPT 5 — Raccourci clavier Cmd+K / Ctrl+K. Ouvre le mode de
     recherche actif via l'unique point d'entree openSearch() (deplie
     la barre inline, ou ouvre le panneau lateral). Remplace le
     raccourci natif Horizon (disparu avec predictive-search.js).
     ============================================================ */
(function() {
  if (!cfg.showInlineSearch && !cfg.showSearchDrawer) return;

  function isEditableTarget(el) {
    if (!el) return false;
    var tag = el.tagName ? el.tagName.toLowerCase() : '';
    return tag === 'input' || tag === 'textarea' || (el.isContentEditable === true);
  }

  function onGlobalKeydown(e) {
    var key = (e.key || '').toLowerCase();
    if (key !== 'k' || (!e.metaKey && !e.ctrlKey)) return;
    if (isEditableTarget(e.target)) return;
    if (document.querySelector('dialog[open]')) return;
    e.preventDefault();
    openSearch();
  }
  document.addEventListener('keydown', onGlobalKeydown);

  document.addEventListener('shopify:section:unload', function(e) {
    if (e.detail.sectionId === cfg.sectionId) {
      document.removeEventListener('keydown', onGlobalKeydown);
    }
  });
})();

  /* ============================================================
     SCRIPT 6 — Mode sombre. Delegation de clic sur
     [data-cds-dark-toggle] (icone header + entree du drawer menu,
     y compris apres teleportation du drawer vers body) : bascule
     la classe cds-dark sur <html>, persiste le choix dans
     localStorage (cle cds_theme_mode : 'dark' / 'light'),
     synchronise aria-pressed / aria-label de TOUS les toggles et
     notifie via l'evenement document 'cds:darkmode'.
     La classe initiale est posee avant le premier paint par le
     early-script anti-flash de layout/theme.liquid ; ici on ne
     fait que resynchroniser l'etat ARIA des boutons rendus.
     Garde window.__cdsDarkModeBound : le script peut etre
     re-execute par l'editeur de theme (shopify:section:load),
     la delegation document ne doit etre posee qu'une fois.
     ============================================================ */
(function() {
  var LABEL_TO_DARK = 'Activer le mode sombre';
  var LABEL_TO_LIGHT = 'Revenir au mode clair';

  function isDark() {
    return document.documentElement.classList.contains('cds-dark');
  }

  function syncToggles() {
    var dark = isDark();
    var btns = document.querySelectorAll('[data-cds-dark-toggle]');
    Array.prototype.forEach.call(btns, function(btn) {
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      btn.setAttribute('aria-label', dark ? LABEL_TO_LIGHT : LABEL_TO_DARK);
    });
  }

  function applyDark(dark) {
    document.documentElement.classList.toggle('cds-dark', dark);
    try {
      localStorage.setItem('cds_theme_mode', dark ? 'dark' : 'light');
    } catch (e) {}
    syncToggles();
    document.dispatchEvent(new CustomEvent('cds:darkmode', { detail: { dark: dark } }));
  }

  if (!window.__cdsDarkModeBound) {
    window.__cdsDarkModeBound = true;
    document.addEventListener('click', function(e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-cds-dark-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      applyDark(!isDark());
    });
    /* Editeur de theme : les sections rechargees re-rendent leurs
       boutons avec l'etat serveur (clair) — on les resynchronise. */
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', syncToggles);
    }
  }

  syncToggles();
})();

  /* ============================================================
     SCRIPT 7 — Modale langue / devise. Delegation de clic :
     [data-cds-lm-open] (globe du header) ouvre le <dialog>
     .cds-lm en top layer via showModal(), [data-cds-lm-close]
     (croix) et le clic sur le fond le ferment. Echap : fermeture
     native du dialog. Le clic-fond marche car la carte interne
     couvre tout le dialog (padding nul) : une cible egale au
     dialog lui-meme ne peut etre que le backdrop.
     Garde window.__cdsLocaleModalBound : la delegation document
     ne doit etre posee qu'une fois malgre les re-executions du
     script par l'editeur de theme.
     ============================================================ */
(function() {
  if (window.__cdsLocaleModalBound) return;
  window.__cdsLocaleModalBound = true;

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;

    var opener = e.target.closest('[data-cds-lm-open]');
    if (opener) {
      e.preventDefault();
      var dlg = document.querySelector('dialog.cds-lm');
      if (dlg && !dlg.open) dlg.showModal();
      return;
    }

    var closer = e.target.closest('[data-cds-lm-close]');
    if (closer) {
      var owner = closer.closest('dialog.cds-lm');
      if (owner) owner.close();
      return;
    }

    if (e.target.matches && e.target.matches('dialog.cds-lm')) {
      e.target.close();
    }
  });
})();
})();
